<template>
    <div>
        <h4>{{title}}</h4>
        <span>{{text}}</span>
    </div>

</template>

<script>
    export default {
        name: "HeaderText",
        props: ['title', 'text'],
        data: () => ({})
    }
</script>

<style scoped>
</style>